import { useCallback } from 'react';

const useReloadPurchaseProcess = () => {
  const reloadPurchaseProcess = useCallback(() => {
    window.location.href = '/purchase';
    return null;
  }, []);

  return reloadPurchaseProcess;
};

export default useReloadPurchaseProcess;
